import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { AdminSidebarComponent } from '../../sidebar/admin-sidebar.component';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { ChallengeDraftsService } from '../challenge-drafts.service';

type ChallengeTab = 'create' | 'scheduled' | 'running' | 'evaluation' | 'completed';

@Component({
  selector: 'app-challenge-home',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    AdminSidebarComponent,
    PageHeaderComponent
  ],
  templateUrl: './challenge-home.component.html',
  styleUrl: './challenge-home.component.scss'
})
export class ChallengeHomeComponent implements OnInit, AfterViewInit, OnDestroy {
  activeTab: ChallengeTab = 'create';
  private routeSubscription?: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private challengeDraftsService: ChallengeDraftsService
  ) {}

  ngOnInit(): void {
    // Set initial tab based on route
    this.updateTabFromRoute();

    // Listen to route changes
    this.routeSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateTabFromRoute();
      });
  }

  ngAfterViewInit(): void {
    // ViewChild is now available after view initialization
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  private updateTabFromRoute(): void {
    const segments = this.router.url.split('/').filter(Boolean);
    const tabParam = segments[segments.length - 1] || 'create';
    if (['create', 'scheduled', 'running', 'evaluation', 'completed'].includes(tabParam)) {
      this.activeTab = tabParam as ChallengeTab;
    } else {
      this.activeTab = 'create';
      this.router.navigate(['/admin/challenge/create']);
    }
  }

  setTab(tab: ChallengeTab): void {
    this.activeTab = tab;
    // Navigate to the corresponding route
    this.router.navigate(['/admin/challenge/' + tab]);
  }

  openDraftsModal(): void {
    this.challengeDraftsService.requestOpenDrafts();
  }
}
